import React, { Component } from 'react';
import PropTypes from 'prop-types';
import hljs from 'highlight.js';

import './styles.css';

class Code extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    hljs.configure({
      classPrefix: 'sc-hljs-'
    });
    hljs.highlightBlock(this.codeBlock);
  }

  render() {
    const { code } = this.props;
    
    /* eslint-disable react/jsx-no-bind */
    return (
      <div>
        <pre><code ref={(codeBlock) => {this.codeBlock = codeBlock;}}>{ code }</code></pre>
      </div>
    );
    /* eslint-enable react/jsx-no-bind */
  }
}

Code.propTypes = {
  code: PropTypes.string.isRequired
};

export default Code;
